/** @format */

import React, { useEffect, useState } from 'react';
import '../../css/modals/Counseling.css';

import { IoClose } from 'react-icons/io5';

import { useSelector, useDispatch } from 'react-redux';

import { closeCounseling } from '../../features/counseling';
import TransparentButton from '../buttons/TransparentButton';

const Advisory = () => {
  const [visibility, setVisibility] = useState('hidden');
  const [container, setContainer] = useState('advisory-closed');

  const modal = useSelector((state) => state.counseling.value.modal);

  const dispatch = useDispatch();

  useEffect(() => {
    if (modal) {
      setVisibility('visible');
      setTimeout(() => {
        setContainer('');
      }, 100);
    }
  }, [modal]);

  const handleCloseModal = (event) => {
    if (event.target.className === 'Advisory') {
      setContainer('advisory-closed');
      setTimeout(() => {
        // handleOpenModal(false);
        dispatch(closeCounseling());
        setVisibility('hidden');
      }, 200);
    }
  };

  return (
    <div
      className='Advisory'
      style={{ visibility: `${visibility}` }}
      onClick={handleCloseModal}>
      <div className={`advisory-container ${container}`}>
        <button
          className='advisory-closer'
          onClick={() => {
            setContainer('advisory-closed');
            setTimeout(() => {
              // handleOpenModal(false);
              dispatch(closeCounseling());
              setVisibility('hidden');
            }, 200);
          }}>
          <IoClose />
        </button>
        <h1>¿Quieres aprender 3D y no sabes cómo iniciar?</h1>
        <h3>¡Entra en contacto directo con nosotros!</h3>
        <p>
          Únete a la charla informativa para clarificar cualquier tipo
          de dudas que puedas tener.
        </p>
        <TransparentButton
          url='https://libel.academy/asesoria'
          name={'Agendar Charla'}
          color={'#6000DE'}
          width={230}
        />
      </div>
    </div>
  );
};

export default Advisory;
